/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import CourseList from './CourseList';

/**
 * Example Component
 * @param {Object.data} data Data from UseInfiniteQuery and useRecipes hook
 * @param {Object.currentPage} currentPage The current page of the recipe list
 * @param {Object.isPending} isPending Whether the loading is pending or not (from useIndustries hook)
 * @param {Object.error} error The error of the data fetch (from useRecipes hook)
 * @param {Object.isError} isError Whether the fetch has an error or not (from useIndustries hook)
 * @returns {JSX.Element}
 */
function CourseResults({ data, isPending, isError }) {
	if (isPending) {
		return (
			<div className="course__results" data-status="loading">
				{__('Loading courses...', 'kotisivu-block-theme')}
			</div>
		);
	}

	if (isError) {
		return (
			<div className="course__results" data-status="error">
				{__('Error fetching courses.', 'kotisivu-block-theme')}
			</div>
		);
	}

	if (Object.keys(data).length === 0) {
		return (
			<div
				className="course__results course__results--empty"
				data-status="not-found"
			>
				{__('No courses found.', 'kotisivu-block-theme')}
			</div>
		);
	}

	return (
		<div className="course__results" data-status="loaded">
			{Object.keys(data).map((month) => {
				return (
					<CourseList
						key={month}
						instances={data[month]}
						month={month}
					/>
				);
			})}
		</div>
	);
}

export default CourseResults;
